import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';
import React, { useContext } from 'react';
import Box from '../../../elements/Box';
import Text from '../../../elements/Text';
import { StyledProps } from '@front10';

interface Props {
  journeyType: string;
  labelKey: string;
}

export type FareItemJourneyTypeProps = StyledProps<Props>;

function FareItemJourneyType(props: FareItemJourneyTypeProps) {
  const { journeyType, labelKey } = props;
  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  return (
    <Box className={`fare-item-journey-type ${className}`} style={style}>
      <Text {...props} floatLeft className="fare-item-type-journey">
        {translate(
          `${labelKey}${journeyType.toLowerCase()}`,
          `${labelKey}${journeyType.toLowerCase()}`
        )}
      </Text>
    </Box>
  );
}

FareItemJourneyType.defaultProps = {
  journeyType: '',
  labelKey: 'cmp-journey-type-options-',
};

FareItemJourneyType.componentName = 'FareItemJourneyType';

export default FareItemJourneyType;
